define(
    'ItemSpecsTable.EntryPoint',
[
    'underscore'
],
function (
    _
) {
    'use strict';

    function buildSpecsTab(item, fields, tabTitle) {
        if (!item) { return null; }

        var rows = _.reduce(fields || [], function reduceFields(acc, field) {

            if (!field || !field.key) {
                return acc;
            }

            var val = item[field.key];
            
            if (!val || !String(val).trim()) {
                return acc;
            }

            return acc +
                '<tr class="item-specs-table-row">' +
                '<th class="item-specs-table-label">' + _.escape(field.label || field.key) + '</th>' +
                '<td class="item-specs-table-value">' + _.escape(String(val)) + '</td>' +
                '</tr>';
        }, '');

        if (!rows) {
            return null;
        }

        return {
            name: tabTitle,
            content: '<div class="table-responsive"><table class="table item-specs-table"><tbody>' + rows + '</tbody></table></div>',
            itemprop: 'description'
        };
    }

    function getSpecsTab(pdp, fields, tabTitle) {
        var itemInfo = pdp.getItemInfo();
        var item = itemInfo && itemInfo.item;
        return buildSpecsTab(item, fields, tabTitle);
    }

    return {
        mountToApp: function mountToApp(container) {
            var layout = container.getComponent('Layout');
            var environment = container.getComponent('Environment');
            var pdp = container.getComponent('PDP');
            var fields = environment.getConfig('itemSpecsTable.fields') || [];
            var tabTitle = environment.getConfig('itemSpecsTable.tabTitle') || 'Details';

            if (!layout || !pdp) {
                return;
            }

            layout.addToViewContextDefinition(
                'ProductDetails.Information.View',
                'details',
                'array',
                function addSpecsDetails(context) {
                    var specsTab = getSpecsTab(pdp, fields, tabTitle);
                    return specsTab ? [specsTab].concat(context.details || []) : context.details;
                }
            );

            layout.addToViewContextDefinition(
                'ProductDetails.Information.View',
                'showInformation',
                'boolean',
                function showInformation(context) {
                    return Boolean(getSpecsTab(pdp, fields, tabTitle) || context.details && context.details.length);
                }
            );

            layout.addToViewContextDefinition(
                'ProductDetails.Information.View',
                'showHeader',
                'boolean',
                function showHeader(context) {
                    var specsTab = getSpecsTab(pdp, fields, tabTitle);
                    var detailsLength = (context.details && context.details.length || 0) + (specsTab ? 1 : 0);
                    return detailsLength < 2;
                }
            );
        }
    };
});
